import { Formik } from 'formik';
import { connect, useDispatch } from 'react-redux';
import { object, string } from 'yup';
import PropTypes from 'prop-types';
import React from 'react';
import pick from 'lodash/pick';

import { historyShape } from '../../app/shapes';
import { selectCurrentMember } from '../selectors';
import { updateMember } from '../actions';
import Modal from '../../app/modal/v2';
import ProfileForm from './profile-form';
import { uploadMemberAvatar } from 'members/api';
import { uploadMedium } from 'story-media/upload-medium';
import { patch } from 'utils/api';
import { receiveEntity, updateEntity } from 'entities/actions';

const ProfileEdit = ({ history: { push, goBack }, member, ...props }) => {
  const dispatch = useDispatch();
  return (
    <Modal closeButtonLeft onClose={() => goBack()} isActive={false}>
      <Modal.InnerWrap>
        <Modal.Title style={{
          color: '#000',
          fontFamily: 'Poppins',
          fontSize: '22px',
          fontWeight: '400',
          lineHeight: '165%',
        }}>My Profile</Modal.Title>
      </Modal.InnerWrap>
      <Formik
        initialValues={{
          'first-name': member['first-name'],
          'last-name': member['last-name'],
          'lock-version': member['lock-version'],
          avatar: '',
          'avatar-canvas-image': '',
        }}
        onSubmit={async ({ avatar, 'avatar-canvas-image': avatarCanvasImage, ...values }, { setSubmitting }) => {
          await props.updateMember(member.id, {
            ...pick(values, ['first-name', 'last-name', 'lock-version']),
          });
          let uploadParams = {
            'lock-version': member?.['lock-version'],
          };
          let updatedMediaId = member['avatar-image'] && member['avatar-image'].id;
          if (avatar instanceof Blob) {
            const result = await uploadMemberAvatar(member.id, avatar.name);
            dispatch(receiveEntity({ result }));

            const medium = result.data.entities.images[result.data.result.images[0]];
            const tmpUrl = URL.createObjectURL(avatar);
            updatedMediaId = medium.id;
            dispatch(
              updateEntity({
                entityType: 'images',
                id: medium.id,
                attrs: { tmpUrl },
              })
            );
            dispatch(
              updateEntity({
                entityType: 'members',
                id: member.id,
                attrs: { ...member, 'avatar-image': { id: updatedMediaId, type: 'images' } },
              })
            );
            // Deliberately not awaited -- the form should not block on S3 -- but now
            // retried, reported, and unable to leave an unhandled rejection.
            uploadMedium({ medium, mediumType: 'Image', file: avatar });
            uploadParams = {
              'lock-version': medium['lock-version'],
            };
          }

          if (avatarCanvasImage?.file instanceof Blob) {
            const { file, ...avatarParams } = avatarCanvasImage;

            const result = await uploadMemberAvatar(member.id, file.name, {
              'owner-type': 'Medium',
              'owner-id': updatedMediaId,
              ...avatarParams
            });

            dispatch(receiveEntity({ result }));
            const medium = result.data.entities.images[result.data.result.images[0]];
            const tmpUrl = URL.createObjectURL(file);

            dispatch(
              updateEntity({
                entityType: 'images',
                id: medium.id,
                attrs: {
                  tmpUrl,
                  ...avatarParams
                },
              })
            );
            uploadMedium({ medium, mediumType: 'Image', file });
            uploadParams = {
              ...uploadParams,
              'canvas-image-id': medium.id,
              ...avatarParams
            };
            if (updatedMediaId) {
              dispatch(
                updateEntity({
                  entityType: 'images',
                  id: updatedMediaId,
                  attrs: { 'canvas-image': { id: uploadParams?.['canvas-image-id'], type: 'images' } },
                })
              );
              await patch(`/v2/media/${updatedMediaId}`, {
                data: {
                  attributes: uploadParams
                }
              })
            }
          }
          setSubmitting(false);
          push('/profile');
        }}
        validationSchema={object().shape({
          'first-name': string().required('First Name is required'),
          'last-name': string().required('Last Name is required'),
        })}
        render={formikProps => <ProfileForm {...formikProps} avatarId={member['avatar-image'].id} />}
      />
    </Modal>
  );
}

ProfileEdit.propTypes = {
  history: historyShape.isRequired,
  member: PropTypes.shape({
    'first-name': PropTypes.string.isRequired,
    'last-name': PropTypes.string.isRequired,
    'lock-version': PropTypes.number.isRequired,
  }).isRequired,
  updateMember: PropTypes.func.isRequired,
  uploadMemberAvatar: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  member: selectCurrentMember(state),
});

export default connect(
  mapStateToProps,
  { updateMember, uploadMemberAvatar }
)(ProfileEdit);
